



































import Vue, { PropOptions } from 'vue';
import StyleType from '@/core/typings/enums/StyleType';
import { ValidationProvider } from 'vee-validate';

interface LocalProps {
  inputValue: PropOptions;
  item: PropOptions;
  placeholder: PropOptions;
  styleType: PropOptions<StyleType>;
  staticFields: PropOptions;
  showImageUpload: PropOptions;
}

export default Vue.extend({
  name: 'HMCheckBoxGroupTeacher',
  components: {
    ValidationProvider,
  },
  props: {
    inputValue: {
      type: String,
      default: null,
    },
    item: {
      type: Object,
    },
    placeholder: {
      type: String,
      default: null,
    },
    styleType: {
      type: String,
      default: 'circle',
    },
    staticFields: {
      type: Boolean,
      default: null,
    },
    showImageUpload: {
      type: Boolean,
      default: null,
    },
  } as LocalProps,
  data() {
    return {
      inputModel: this.inputValue,
    };
  },
});
